module.exports = __webpack_public_path__ + "img/2_accident-car-sp.ef11604e.gif";